import React, { useState } from 'react';
import { NavLink } from "react-router-dom"; // Import NavLink instead of Link

function NavBar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);

  return (
    <div>
      <div className={click ? "main-container1" : ""} onClick={() => Close()} />
      <nav className="navbar1" onClick={e => e.stopPropagation()}>
        <div className="nav-container1">
          <div className="nav-logo1">
            <NavLink to="/" exact>
              <img src="../../img2/logo.png" alt="logo" style={{ width: "120px" }} />
            </NavLink>
          </div>
          
          <ul className={click ? "nav-menu1 active1" : "nav-menu1"}>
            <li className="nav-item1">
              <NavLink
                to="/job_suchen"
                exact
                className={({ isActive }) => (isActive ? "nav-links1 active1" : "nav-links1")}
                onClick={click ? handleClick : null}
              >
                Jobs suchen 
              </NavLink>
            </li>
            <li className="nav-item1 active1">
              <NavLink
                to="/"
                exact
                className={({ isActive }) => (isActive ? "nav-links1 active1" : "nav-links1")}
                onClick={click ? handleClick : null}
              >
                Für Bewerber
              </NavLink>
            </li>
            <li className="nav-item1">
              <a
                href="https://unternehmen.hello-sister.de/"
                className="nav-links1"
                onClick={click ? handleClick : null}
              >
                Für Unternehmen
              </a>
            </li>
            <li className="nav-item1">
              <NavLink
                to="/login"
                exact
                className={({ isActive }) => (isActive ? "nav-links1 active1" : "nav-links1")}
                onClick={click ? handleClick : null}
              >
                Einloggen
              </NavLink>
            </li>
            <li className="nav-item1">
              <NavLink
                to="/register"
                exact
                className={({ isActive }) => (isActive ? "nav-links1 active1" : "nav-links1")}
                onClick={click ? handleClick : null}
              >
                Registrieren
              </NavLink>
            </li>
          </ul>
          <div className="nav-icon1" onClick={handleClick}>
            <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default NavBar;
